import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../services/firestore/settings.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  constructor(public settingsService: SettingsService) { }

  ngOnInit(): void {
    this.settingsService.selectedMenu = "home";
    this.settingsService.reviewsTabActive = false;
  }

  isChromeExtension() {
    return environment.environmentName === 'extension';
  }

}
